import { getCustomPlatformAuthenticateLocalUserMockHandler } from './getPlatformAuthenticateLocalUserMockHandler';
import { getCustomPlatformCreateTeamMockHandler } from './getPlatformCreateTeamMockHandler';
import { getCustomPlatformExecuteAdHocQueryTeamMockHandler } from './getPlatformExecuteAdHocQueryTeamMockHandler';
import { getCustomPlatformGetCurrentLocalUserMockHandler } from './getPlatformGetCurrentLocalUserMockHandler';
import { getCustomPlatformGetCurrentUserMembershipsMockHandler } from './getPlatformGetCurrentUserMembershipsMockHandler';
import { getCustomPlatformGetCurrentUserMockHandler } from './getPlatformGetCurrentUserMockHandler';
import { getCustomPlatformGetLocalUserMockHandler } from './getPlatformGetLocalUserMockHandler';
import { getCustomPlatformGetSyncRunLogsMockHandler } from './getPlatformGetSyncRunLogsMockHandler';
import { getCustomPlatformGetSyncRunMockHandler } from './getPlatformGetSyncRunMockHandler';
import { getCustomPlatformGetSyncRunStatsMockHandler } from './getPlatformGetSyncRunStatsMockHandler';
import { getCustomPlatformGetSyncRunTablesMockHandler } from './getPlatformGetSyncRunTablesMockHandler';
import { getCustomPlatformGetSyncSourceMockHandler } from './getPlatformGetSyncSourceMockHandler';
import { getCustomPlatformListLocalUsersMockHandler } from './getPlatformListLocalUsersMockHandler';
import { getCustomPlatformListSyncRunsMockHandler } from './getPlatformListSyncRunsMockHandler';
import { getCustomPlatformListSyncsMockHandler } from './getPlatformListSyncsMockHandler';
import { getCustomPlatformListTeamsMockHandler } from './getPlatformListTeamsMockHandler';
import { getCustomPlatformLoginUserMockHandler } from './getPlatformLoginUserMockHandler';
import { getCustomPlatformLogoutUserMockHandler } from './getPlatformLogoutUserMockHandler';
import { getCustomPlatformManageGetPlatformRegistryMockHandler } from './getPlatformManageGetPlatformRegistryMockHandler';
import { getCustomPlatformManageRegisterPlatformMockHandler } from './getPlatformManageRegisterPlatformMockHandler';
import { getCustomPlatformTableListRowsMockHandler } from './getPlatformTableListRowsMockHandler';

export const customHandlers = [
  getCustomPlatformAuthenticateLocalUserMockHandler(),
  getCustomPlatformLoginUserMockHandler(),
  getCustomPlatformLogoutUserMockHandler(),
  getCustomPlatformTableListRowsMockHandler(),
  getCustomPlatformGetCurrentUserMockHandler(),
  getCustomPlatformGetCurrentUserMembershipsMockHandler(),
  getCustomPlatformManageGetPlatformRegistryMockHandler(),
  getCustomPlatformManageRegisterPlatformMockHandler(),
  getCustomPlatformCreateTeamMockHandler(),
  getCustomPlatformExecuteAdHocQueryTeamMockHandler(),
  getCustomPlatformGetLocalUserMockHandler(),
  getCustomPlatformListLocalUsersMockHandler(),
  getCustomPlatformListTeamsMockHandler(),
  getCustomPlatformListSyncsMockHandler(),
  getCustomPlatformGetCurrentLocalUserMockHandler(),
  getCustomPlatformGetSyncSourceMockHandler(),
  getCustomPlatformListSyncRunsMockHandler(),
  getCustomPlatformGetSyncRunMockHandler(),
  getCustomPlatformGetSyncRunStatsMockHandler(),
  getCustomPlatformGetSyncRunTablesMockHandler(),
  getCustomPlatformGetSyncRunLogsMockHandler(),
];
